import Constant, { WEB_HOST } from "utils/headFootConstants";

/** App 下载页面 */
export const APP_DOWNLOAD = () => {
	return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].host}/nh/App-Download.html`;
};
/** iOS 下载页面 */
export const IOS_DOWNLOAD =
	"https://itunes.apple.com/us/app/mini-all-small-gadgets-brought/id737435913";
/** android 下载页面 */
export const ANDROID_DOWNLOAD =
	"https://play.google.com/store/apps/details?id=com.miniinthebox.android";
/** 顾客服务页面 */
export const CUSTOMER_SERVICE = () => {
	return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/r/contact-us.html`;
};
/** 中转页面 */
export const MIDDLE_QUERY = () => {
	return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/index.php?main_page=`;
};
/** 搜索页面 */
export const SEARCH_RESULT = () => {
	return `${
		WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost
	}/index.php?main_page=advanced_search_result&inc_subcat=1&search_in_description=0&keyword=`;
};
